import React from 'react';
import { Container, Button } from 'semantic-ui-react';
import { FormattedMessage } from 'react-intl';
import OrderPreview from './OrderPreview';

const OrderCanceledView = (props) => {
  const { status } = props;
  const onReOpen = React.useCallback(() => {
    // eslint-disable-next-line no-console
    console.log(props);
  }, [props]);
  return (
    <Container>
      <OrderPreview fluid={true} status={status} {...props}>
        <Button onClick={onReOpen} color="orange" fluid>
          <FormattedMessage id="Reopen" defaultMessage="Reopen" />
        </Button>
      </OrderPreview>
    </Container>
  );
};

export default OrderCanceledView;
